import script from "./ConfirmAddressList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmAddressList.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmAddressList.vue?vue&type=style&index=0&id=0b107e28&lang=scss"

const __exports__ = script;

export default __exports__